export const getQeury = () => {
  const Obj: any = {};

  const queryString = window.location.search.slice(1);

  const queryArr = queryString.split("&");

  queryArr.map(e => {
    const _t = e.split("=");

    // 检测是否存在相同
    if (!(_t[0] in Obj)) {
      Obj[_t[0]] = _t[1];
    }
    return e;
  });
  return Obj;
};

export const getQueryString = (name: string) => {
  const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  const result = window.location.search.substr(1).match(reg);
  if (result != null) {
    return result[2];
  } else {
    return null;
  }
};



// WEBPACK FOOTER //
// ./src/publics/tool/getQuery.ts